<div class="dialog-title-row" fxLayout="row" fxLayoutAlign="space-between center">
  <h2 mat-dialog-title>
    {{ data.title }}
    <span class="somente-leitura">somente leitura</span>
  </h2>
  <button mat-icon-button class="close-button" (click)="close()" aria-label="Fechar">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="dialog-content">

  <app-conversa-mensagens
    [mensagens]="mensagens"
    [carregando]="carregando"
    vazioTitulo="Nenhuma conversa registrada para este cliente."
    [comFundo]="false">
  </app-conversa-mensagens>

  <mat-paginator
    *ngIf="length > pageSize"
    [length]="length"
    [showFirstLastButtons]="true"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="mudarPagina($event)">
  </mat-paginator>
</div>
